
import {urlConfig} from '@/api/urlConfig'
import {fetch, promptMessage, baseUrl } from '@/api/dataHandling'
import {getken} from '@/api/getToken'
import {diseaseCommon} from '@/api/diseaseCommon'
import axios from 'axios'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default {
data () {
return {
toastShow: false,
toastTxt: '',
iconArry: {
chuchaoIcon: false,
yuejingtianshuIcon: false,
yuejingzhouqijiangeIcon: false,
rengongliuchanIcon: false,
ziranliuchanIcon: false,
yaoliuIcon: false,
yinchanIcon: false,
zaochanIcon: false,
gongwaiyunzuoIcon: false,
gongwaiyunyouIcon: false,
zuyuechanIcon: false,
poufuchanIcon: false,
shunchanIcon: false,
xianyouzinvIcon: false
},
nameIcon: false,
phoneNoIcon: false,
nationalityIcon: false,
birthdayIcon: false,
causeIcon: false,
sourceIcon: false,
maritalStatusIcon: false,
seeTypeIcon: false,
educationDegreeIcon: false,
cardTypeIcon: false,
cardNoIcon: false,
divisionIdIcon: false,
addressIcon: false,
familyIcon: false,
shiTxtIcon: false,
shengIcon: false,
shengaoIcon: false,
weightIcon: false,
diseaseCommon,
sourceread: true,
ZJread: true,
submitDisable: false,
lookIf: false,
yuejingtianshu: '',
yuejingzhouqijiange: '',
mocirenshendate: '',
baseBool: false,
penqiangyanIf: false,
shoushushiIf: false,
xiyanIf: false,
zhongdajingshencijishiIf: false,
xiguanyongyaoIf: false,
yaowuguominshiIf: false,
chushenquexianIf: false,
lingyangzinvIf: false,
yichuanbingshiIf: false,
buyunbuyuIf: false,
shengTxt: '',
shiTxt: '',
sex: '女',
basedata: {
addressType: '09',
name: '',
gender: '2',
nationality: '',
birthday: '',
phoneNo: '',
cause: '',
source: '',
maritalStatus: '',
divisionId: '',
address: '',
family: '2',
cardNo: '',
cardType: '',
seeType: '',
educationDegree: ''
},
objdata: {
bingliriqi: '',
bingshicaijizhe: '',
bingshixiaojiebeizhu: '',
chuzhibeizhu: '',
fuzhushengzhitezheng: '',
fuzhushengzhitezhengriqi: '',
maibo: '',
rssEmrTypeId: '',
rssEmrVerId: '',
sgrjbxxId: '',
tiwen: '',
xinlv: '',
xueya: '',
xianbingshi: '',
yishi: '',
zhenduanbz1: '',
zhenduanbz2: '',
zhenduanbz3: '',
zhenduanbz4: '',
zhenduanbz5: '',
zhushu: '',
shengao: '',
tizhong: '',
tizhongzhishu: '',
ganyan: '无',
jiehe: '无',
shenzangjibing: '无',
xinxueguanjibing: '无',
miniaoxitongganran: '无',
xingbingchuanbojbs: '无',
lanweiyan: '无',
penqiangyan: '无',
penqiangyanbeizhu: '',
shoushushi: '无',
shoushushibeizhu: '',
jiwangbingshiqita: '无',
xiyan: '无',
xiyanzhishu: '',
xujiu: '无',
xidu: '无',
zhongdajingshencijishi: '无',
zhongdajingshencijishibz: '',
xiguanyongyao: '无',
xiguanyongyaobz: '',
yaowuguominshi: '无',
yaowuguominshibeizhu: '',
chushenquexian: '无',
chushengquexianbeizhu: '',
jiankangguoqu: '良好',
jiangkangxianzai: '良好',
chuchao: '',
yuejingzhouqi: '',
jingliang: '正常',
tongjing: '无',
jinqinjiehun: '否',
zaihun: '否',
renshen: '否',
mocirenshennian: '',
mocirenshenyue: '',
yun: '0',
chan: '0',
rengongliuchan: '0',
ziranliuchan: '0',
yaoliu: '0',
yinchan: '0',
zaochan: '0',
gongwaiyunzuo: '0',
gongwaiyunyou: '0',
gongwaiyunbeizhu: '',
zuyuechan: '0',
poufuchan: '',
shunchan: '',
xianyouzinv: '',
lingyangzinv: '否',
lingyangzinvsl: '',
hunyushiqita: '',
yichuanbingshi: '无',
yichuanbingshibeizhu: '',
buyunbuyu: '无',
buyunbuyubeizhu: ''
},
nationOptions: [],
marriageOptions: [],
ZYOptions: [],
HZLYOptions: [],
JZTypeOptions: [],
ZJTypeOptions: [],
whcdOptions: [],
familyOptions: [
{
key: '1',
value: '有'
},
{
key: '2',
value: '无'
}
],
shengOptions: [],
jiankangoptions: [],
shiOptions: [],
divisionOptions: [],
genifoptions: ['无', '有'],
genyesoptions: ['否', '是'],
jingliangOptions: ['正常', '多', '少'],
tradeData: [],
trade: '',
tradeName: '',
tradeId: '',
showPopup: false
}
},
directives: {
TransferDom
},
components: {
Popup, Cell, Checker, CheckerItem, Checklist, Toast, Icon, Grid, GridItem, GroupTitle, PopupPicker, Flexbox, FlexboxItem, Datetime, XTextarea, XInput, XHeader, Radio, XButton, Group, PopupRadio
},
methods: {
moveCursor (obj) {
}, // 移动光标
iftrim () {
this.requiredMethod(
[this.basedata.name, 'nameIcon', true],
[this.basedata.nationality, 'nationalityIcon', true],
[this.basedata.cause, 'causeIcon', true],
[this.basedata.birthday, 'birthdayIcon', true],
[this.basedata.source, 'sourceIcon', true],
[this.basedata.maritalStatus, 'maritalStatusIcon', true],
[this.basedata.seeType, 'seeTypeIcon', true],
[this.basedata.cardType, 'cardTypeIcon', true],
[this.basedata.divisionId, 'divisionIdIcon', true],
[this.basedata.address, 'addressIcon', true],
[this.basedata.family, 'familyIcon', true],
[this.shengTxt, 'shengIcon', true],
[this.shiTxt, 'shiTxtIcon', true],
[this.basedata.educationDegree, 'educationDegreeIcon', true],
[this.objdata.chuchao, 'chuchaoIcon', false],
[this.yuejingtianshu, 'yuejingtianshuIcon', false],
[this.yuejingzhouqijiange, 'yuejingzhouqijiangeIcon', false],
[this.objdata.rengongliuchan, 'rengongliuchanIcon', false],
[this.objdata.ziranliuchan, 'ziranliuchanIcon', false],
[this.objdata.yaoliu, 'yaoliuIcon', false],
[this.objdata.yinchan, 'yinchanIcon', false],
[this.objdata.zaochan, 'zaochanIcon', false],
[this.objdata.gongwaiyunzuo, 'gongwaiyunzuoIcon', false],
[this.objdata.gongwaiyunyou, 'gongwaiyunyouIcon', false],
[this.objdata.zuyuechan, 'zuyuechanIcon', false],
[this.objdata.poufuchan, 'poufuchanIcon', false],
[this.objdata.shunchan, 'shunchanIcon', false],
[this.objdata.xianyouzinv, 'xianyouzinvIcon', false]
)
this.$nextTick(function () {
this.telchange()
this.SFZvalidate()
this.weightType()
this.heightType()
})
}, // 判断是否为空
ZJtypeChange () {
this.basedata.cardNo = ''
},
telchange () {
let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
this.$nextTick(function () {
this.basedata.phoneNo = this.basedata.phoneNo.trim().replace(patrn, '')
if (/^1[3456789]\d{9}$/.test(this.basedata.phoneNo)) {
this.phoneNoIcon = false
} else {
this.phoneNoIcon = true
if (!this.basedata.phoneNo) {
return false
}
this.IconClick('电话号码格式不正确，请核实！')
}
})
},
SFZvalidate () {
let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
if (this.basedata.cardType == '01' || this.basedata.cardType == '04') {
this.$nextTick(function () {
this.basedata.cardNo = this.basedata.cardNo.trim().replace(patrn, '')
if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.basedata.cardNo))) {
this.cardNoIcon = true
if (!this.basedata.cardNo) {
return false
}
promptMessage('提示', '证件号码不正确，请核实！')
} else {
this.cardNoIcon = false
}
})
}
}, // 验证身份证
getnationData () {
this.getData()
this.nationOptions = []
fetch('get', urlConfig.getNation).then(response => {
for (let i = 0; i < response.length; i++) {
this.nationOptions.push({key: response[i].smzDm, value: response[i].smzCmc})
}
}).catch(error => {
})// 获取民族
fetch('get', urlConfig.getmarriage).then(response => {
for (let i = 0; i < response.length; i++) {
this.marriageOptions.push({key: response[i].sHyzkDm, value: response[i].sHyzkCmc})
}
}).catch(error => {

})  // 获取婚姻
fetch('get', urlConfig.getZY).then(response => {
for (let i = 0; i < response.length; i++) {
this.ZYOptions.push({key: response[i].sgrsfDm, value: response[i].sgrsfCmc})
}
}).catch(error => {

})  // 获取职业
fetch('get', urlConfig.getHZLY).then(response => {
for (let i = 0; i < response.length; i++) {
this.HZLYOptions.push({key: response[i].sScqdDm, value: response[i].sScqdCmc})
}
}).catch(error => {

})  // 获取来源
fetch('get', urlConfig.getJZType).then(response => {
for (let i = 0; i < response.length; i++) {
this.JZTypeOptions.push({key: response[i].sCzlxDm, value: response[i].sCzlxCmc})
}
}).catch(error => {

})  // 获取就诊类型
fetch('get', urlConfig.getZJType).then(response => {
for (let i = 0; i < response.length; i++) {
this.ZJTypeOptions.push({key: response[i].sGtbshDm, value: response[i].sGtbshCmc})
}
}).catch(error => {

})  // 获取证件类型
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token')
axios.post(baseUrl + urlConfig.getwhcd).then(response => {
for (let i = 0; i < response.data.length; i++) {
this.whcdOptions.push({key: response.data[i].swhcdDm, value: response.data[i].swhcdCmc})
}
}).catch(error => {

})  // 获取文化程度
axios.get(baseUrl + urlConfig.getIVF + '/216').then(response => {
for (let i = 0; i < response.data.data.length; i++) {
this.jiankangoptions.push(response.data.data[i].sZdCmc)
}
}).catch(error => {

})  // 获取获取健康状态
this.addressChange(0, 'shengOptions')

this.getTags()
},
addressChange (id, option, txt) {
this[option] = []
if (id !== '') {
fetch('get', urlConfig.getsheng + id).then(response => {
for (let i = 0; i < response.length; i++) {
this[option].push({key: response[i].id, value: response[i].sXzqhCmc})
}
if (txt) {
if (txt == 'shiTxt') {
this.basedata.divisionId = ''
} else if (txt == 'shengTxt') {
this.basedata.divisionId = ''
this.shiTxt = ''
}
}
this.iftrim()
}).catch(error => {

})  // 获取 省
}
},
heightType () {
this.$nextTick(function () {
this.objdata.shengao = (this.objdata.shengao).replace(/[^\d]/g, '').trim()
if (Number(this.objdata.shengao) > 240 || Number(this.objdata.shengao) < 100) {
this.shengaoIcon = true
if (!this.objdata.shengao) {
return false
}
this.IconClick('输入值有误，身高单位是厘米，请核实后填写！')
} else {
this.shengaoIcon = false
}
})
},
weightType () {
this.$nextTick(function () {
this.objdata.tizhong = (this.objdata.tizhong).replace(/[^\d.]/g, '')
if (Number(this.objdata.tizhong) > 300 || Number(this.objdata.tizhong) < 25) {
this.weightIcon = true
if (!this.objdata.tizhong) {
return false
}
this.IconClick('输入值有误，体重单位是千克，请核实后填写！')
} else {
this.weightIcon = false
}
})
},
alertHide (obj) {
let _this = this
return function () {
_this.$nextTick(function () {
_this.objdata[obj] = ''
})
}
},
getData () {
this.$store.commit('updateLoadingStatus', {isLoading: true})
this.SubmitData = {}
fetch('get', urlConfig.perfectMessageWomanUrl + '/' + this.rssEmrTypeId + '/' + this.rssEmrVerId + '/' + this.sgrjbxxId).then(response => {
this.SubmitData.rssEmrTypeId = this.rssEmrTypeId
this.SubmitData.rssEmrVerId = this.rssEmrVerId
this.SubmitData.sgrjbxxId = this.sgrjbxxId
if (response.personInfo.birthday) {
response.personInfo.birthday = (response.personInfo.birthday).substring(0, (response.personInfo.birthday).lastIndexOf(' '))
}
for (let i in response.personInfo) {
if (response.personInfo[i] == null) {
response.personInfo[i] = ''
}
}
this.basedata = response.personInfo
this.basedata.addressType = '09'
if (!this.basedata.divisionId) {
this.shengTxt = 'SSM20180424001510000'
this.addressChange(this.shengTxt, 'shiOptions')
} else {
fetch('get', urlConfig.getFsheng + this.basedata.divisionId).then(response => {
this.shiTxt = response[0].cityId
this.shengTxt = response[0].provinceId
this.addressChange(this.shengTxt, 'shiOptions')
this.addressChange(this.shiTxt, 'divisionOptions')
}).catch(error => {

})
}
if (response.record.id == undefined || response.record.id == null) { // 新增
this.SubmitData.createUserId = this.sgrjbxxId
this.lookIf = true
this.sourceread = false
this.ZJread = false
} else { // 修改
this.SubmitData.lastUpdateUserId = response.lastUpdateUserId
this.SubmitData.id = response.id
for (let i in response.record) {
if (response.record[i] == null) {
response.record[i] = ''
}
}
this.objdata = response.record
let zhouqiIndex = this.objdata.yuejingzhouqi.indexOf('/')
this.yuejingtianshu = this.objdata.yuejingzhouqi.substring(0, zhouqiIndex)
this.yuejingzhouqijiange = this.objdata.yuejingzhouqi.substring(zhouqiIndex + 1)
if (this.objdata.mocirenshennian.trim() != '' && this.objdata.mocirenshenyue.trim() != '') {
this.mocirenshendate = this.objdata.mocirenshennian.trim() + '-' + this.objdata.mocirenshenyue.trim()
}
}
if (response.status == 1) {  // 能修改
this.lookIf = true

if (response.personInfo.source == '') {
this.sourceread = false
} else {
this.sourceread = true
}
if (response.personInfo.cardNo == '') {
this.ZJread = false
} else {
this.ZJread = true
}
} else {   // 不能修改
this.lookIf = false
this.ZJread = true
this.sourceread = true
promptMessage('提示', '该条个人信息已通过医生审核，不能再自行修改了！')
}
this.iftrim()
this.$store.commit('updateLoadingStatus', {isLoading: false})
}).catch(error => {

})
},
noxiaoshuType (obj, bloon, name) {
if (bloon) {
this.$nextTick(function () {
this.objdata[obj] = (this.objdata[obj]).replace(/[^\d]/g, '')
if (this.objdata[obj].length > 1) {
this.objdata[obj] = (this.objdata[obj]).replace(/^0*!/g, '')
}
if (name && this.objdata[obj]) {
this.$refs[name].focus()
}
})
} else {
this.$nextTick(function () {
this[obj] = this[obj].replace(/[^\d]/g, '')
if (this[obj].length > 1) {
this[obj] = (this[obj]).replace(/^0*/g, '')
}
if (name && this[obj]) {
this.$refs[name].focus()
}
})
}
this.iftrim()
},
sureClick () {
this.iftrim()
if (this.mocirenshendate != '') {
let index = this.mocirenshendate.indexOf('-')
this.objdata.mocirenshennian = this.mocirenshendate.substring(0, index)
this.objdata.mocirenshenyue = this.mocirenshendate.substring(index + 1)
}

if (this.objdata.shengao.trim() != '' && this.objdata.tizhong.trim() != '') {
this.objdata.tizhongzhishu = (Number(this.objdata.tizhong) / Math.pow((Number(this.objdata.shengao) / 100), 2)).toFixed(2)
} else {
this.objdata.tizhongzhishu = ''
}  // 计算体重指数
this.objdata.yuejingzhouqi = this.yuejingtianshu + '/' + this.yuejingzhouqijiange

if (this.objdata.rengongliuchan.trim() != '' && this.objdata.ziranliuchan.trim() != '' && this.objdata.yaoliu.trim() != '' && this.objdata.yinchan.trim() != '' && this.objdata.gongwaiyunzuo.trim() != '' && this.objdata.gongwaiyunyou.trim() != '') {
this.objdata.yun = Number(this.objdata.rengongliuchan) + Number(this.objdata.ziranliuchan) + +Number(this.objdata.yaoliu) + +Number(this.objdata.yinchan) + +Number(this.objdata.gongwaiyunzuo) + +Number(this.objdata.gongwaiyunyou)
} // 计算怀孕
if (this.objdata.zaochan.trim() != '' && this.objdata.zuyuechan.trim() != '') {
this.objdata.chan = Number(this.objdata.zaochan) + Number(this.objdata.zuyuechan)
}
this.SubmitData.clBcXml = this.clBcXml.temp(this.objdata)
this.SubmitData.record = this.objdata
this.SubmitData.personInfo = this.basedata
let baseIndex = 0
for (let i in this.basedata) {
if (this.basedata[i]) {
baseIndex++
} else {
this.toastShow = true
this.toastTxt = '还有选项未填写'
if (i == 'divisionId' || i == 'address') {
$('body ,html').scrollTop($('#adressID').position().top - 50)
return false
} else {
$('body ,html').scrollTop(0)
return false
}
}
}
let bingindex = 0

for (let i in this.iconArry) {
if (!this.iconArry[i]) {
bingindex++
} else {
this.toastShow = true
this.toastTxt = '还有选项未填写'
if (i == 'chuchaoIcon' || i == 'yuejingtianshuIcon' || i == 'yuejingzhouqijiangeIcon') {
$('body ,html').scrollTop($('#yuejingshiID').position().top - 50)
return false
} else {
$('body ,html').scrollTop($('#hunyushiID').position().top + 100)
return false
}
}
}
if (bingindex == Object.keys(this.iconArry).length && baseIndex == Object.keys(this.basedata).length && !this.cardNoIcon && !this.phoneNoIcon && !this.shengaoIcon && !this.weightIcon) {  // 提交
this.submitDisable = true
this.$store.commit('updateLoadingStatus', {isLoading: true})
fetch('post', urlConfig.perfectMessageWomanUrl, this.SubmitData).then(response => {
this.$store.commit('updateLoadingStatus', {isLoading: false})

this.saveTags()
promptMessage('提示', '提交成功!', function () {
window.location.reload()
})
}).catch(error => {
this.submitDisable = false
this.$store.commit('updateLoadingStatus', {isLoading: false})
})
} else {
promptMessage('提示', '您的信息还未全部填写，不能提交！')
this.iftrim()
if (!this.shengaoIcon || !this.weightIcon) {
$('body ,html').scrollTop($('#shengaoID').position().top - 50)
}
}
}, // 提交
colse () {
WeixinJSBridge.call('closeWindow')
},
radioChoose (obj, objBZ) {
if (this.objdata[obj] == '无' || this.objdata[obj].trim() == '' || this.objdata[obj] == '否') {
this[obj + 'If'] = false
this.objdata[objBZ] = ''
} else {
this[obj + 'If'] = true
}
if (this.objdata[obj] == '无' || this.objdata[obj] == '否') {
this.beizhuifobj[objBZ] = false
} else {
this.beizhuifobj[objBZ] = true
}
}, // 是否显示备注
requiredMethod () {
for (let i = 0; i < arguments.length; i++) {
if (arguments[i][2]) {
if (!arguments[i][0].trim()) {
this[arguments[i][1]] = true
} else {
this[arguments[i][1]] = false
}
} else {
if (!arguments[i][0].trim()) {
this.iconArry[arguments[i][1]] = true
} else {
this.iconArry[arguments[i][1]] = false
}
}
}
}, // 是否必填
IconClick (text) {
this.toastShow = true
this.toastTxt = text
},
saveTags () {
let tradeTemp = {}
tradeTemp.personInfoId = this.sgrjbxxId
tradeTemp.tagId = this.trade
tradeTemp.id = this.tradeId
tradeTemp.userId = this.sgrjbxxId
if (!tradeTemp.tagId) {
return
}

fetch('post', urlConfig.saveTag, tradeTemp).then(response => {
}).catch(error => {
console.log(error)
})
},
getTags () {

fetch('post', urlConfig.queryUsableTags, { tagTypeCate: '1', personInfoId: this.sgrjbxxId }).then(response => {
const {tagCates, personTags} = response
if (tagCates.length > 0) {
this.tradeData = tagCates[0].tags
}
if (personTags.length > 0) {
this.tradeName = personTags[0].tagName
this.trade = personTags[0].tagId
this.tradeId = personTags[0].id
}
}).catch(error => {
console.log(error)
})
}
},
mounted () {
let _this = this
this.rssEmrTypeId = this.$route.query.rssEmrTypeId
this.rssEmrVerId = this.$route.query.rssEmrVerId
this.sgrjbxxId = this.$route.query.sgrjbxxId
getken(this.getnationData)
String.prototype.temp = function (obj) {
return this.replace(/\$\w+\$/gi, function (matchs) {
var returns = obj[matchs.replace(/\$/g, '')]
return (returns + '') == 'undefined' ? '' : returns
})
}
this.$nextTick(function () {
$('.inputClick').on('click', function () {
if (_this.lookIf) {
$(this).find('input, .textarea').focus()
}
})
/*    if(_this.lookIf){
$('.inputClick').find('input, .textarea').focus();
} */
})
this.clBcXml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
'<?xml-stylesheet type="text/xsl" href="includeXsl"?>\n' +
'<zhouqimenzhenbingli>\n' +
'  <!-- 基础信息 -->\n' +
'  <jichuxinxi>\n' +
'    <fuzhushengzhitezheng required="1" cn="ART">无</fuzhushengzhitezheng>\n' +
'    <fuzhushengzhitezhengriqi cn="ART日期"></fuzhushengzhitezhengriqi>\n' +
'    <zhusu required="1" cn="主诉">$zhushu$</zhusu>\n' +
'    <xianbingshi required="1" cn="现病史">$xianbingshi$</xianbingshi>\n' +
'    <tiwen required="1" cn="T">$tiwen$</tiwen>\n' +
'    <xinlv required="1" cn="P">$xinlv$</xinlv>\n' +
'    <maibo required="1" cn="R">$maibo$</maibo>\n' +
'    <xueya required="1" cn="BP">$xueya$</xueya>\n' +
'    <shengao required="1" cn="身高">$shengao$</shengao>\n' +
'    <tizhong required="1" cn="体重">$tizhong$</tizhong>\n' +
'    <tizhongzhishu required="1" cn="体重指数">$tizhongzhishu$</tizhongzhishu>\n' +
'  </jichuxinxi>\n' +
'\n' +
'  <!-- 既往病史 -->\n' +
'  <jiwangbingshi>\n' +
'    <ganyan required="1" cn="肝炎">$ganyan$</ganyan>\n' +
'    <jiehe required="1" cn="结核">$jiehe$</jiehe>\n' +
'    <shenzangjibing required="1" cn="肾脏疾病">$shenzangjibing$</shenzangjibing>\n' +
'    <xinxueguanjibing required="1" cn="心血管疾病">$xinxueguanjibing$</xinxueguanjibing>\n' +
'    <miniaoxitongganran required="1" cn="泌尿系统感染">$miniaoxitongganran$</miniaoxitongganran>\n' +
'    <xingbingchuanbojbs required="1" cn="性传播疾病史">$xingbingchuanbojbs$</xingbingchuanbojbs>\n' +
'    <lanweiyan required="1" cn="阑尾炎">$lanweiyan$</lanweiyan>\n' +
'    <penqiangyan required="1" cn="盆腔炎">$penqiangyan$</penqiangyan>\n' +
'    <penqiangyanbeizhu>$penqiangyanbeizhu$</penqiangyanbeizhu>\n' +
'    <shoushushi required="1" cn="手术史">$shoushushi$</shoushushi>\n' +
'    <shoushushibeizhu>$shoushushibeizhu$</shoushushibeizhu>\n' +
'    <qita required="1" cn="其他">$jiwangbingshiqita$</qita>\n' +
'  </jiwangbingshi>\n' +
'\n' +
'  <!-- 个人史 -->\n' +
'  <gerenshi>\n' +
'    <xiyan required="1" cn="吸烟">$xiyan$</xiyan>\n' +
'    <xiyanzhishu>$xiyanzhishu$</xiyanzhishu>\n' +
'    <xujiu required="1" cn="酗酒">$xujiu$</xujiu>\n' +
'    <xidu required="1" cn="吸毒">$xidu$</xidu>\n' +
'    <xiguanyongyao required="1" cn="习惯用药">$xiguanyongyao$</xiguanyongyao>\n' +
'    <xiguanyongyaobz cn="习惯用药备注">$xiguanyongyaobz$</xiguanyongyaobz>\n' +
'    <yaowuguominshi required="1" cn="药物过敏史">$yaowuguominshi$</yaowuguominshi>\n' +
'    <yaowuguominshibeizhu>$yaowuguominshibeizhu$</yaowuguominshibeizhu>\n' +
'    <zhongdajingshencijishi required="1" cn="重大精神刺激史">$zhongdajingshencijishi$</zhongdajingshencijishi>\n' +
'    <zhongdajingshencijishibz cn="">$zhongdajingshencijishibz$</zhongdajingshencijishibz>\n' +
'    <jiankangguoqu required="1" cn="健康状况:过去">$jiankangguoqu$</jiankangguoqu>\n' +
'    <jiankangxianzai cn="健康状况:现在">$jiangkangxianzai$</jiankangxianzai>\n' +
'    <chushenquexian required="1" cn="出生缺陷">$chushenquexian$</chushenquexian>\n' +
'    <chushengquexianbeizhu cn="出生缺陷备注">$chushengquexianbeizhu$</chushengquexianbeizhu>\n' +
'  </gerenshi>\n' +
'\n' +
'  <!-- 月经史 -->\n' +
'  <yuejingshi>\n' +
'    <chuchao required="1" cn="初潮">$chuchao$</chuchao>\n' +
'    <yuejingzhouqi required="1" cn="月经周期">$yuejingzhouqi$</yuejingzhouqi>\n' +
'    <jingliang required="1" cn="经量">$jingliang$</jingliang>\n' +
'    <tongjing required="1" cn="痛经">$tongjing$</tongjing>\n' +
'  </yuejingshi>\n' +
'\n' +
'  <!-- 婚育史 -->\n' +
'  <hunyushi>\n' +
'    <jinqinjiehun required="1" cn="近亲结婚">$jinqinjiehun$</jinqinjiehun>\n' +
'    <zaihun required="1" cn="再婚">$zaihun$</zaihun>\n' +
'    <renshen required="1" cn="妊娠">$renshen$</renshen>\n' +
'    <mocirenshennian required="1" cn="末次妊娠时间:年">$mocirenshennian$</mocirenshennian>\n' +
'    <mocirenshenyue required="1" cn="末次妊娠时间:月">$mocirenshenyue$</mocirenshenyue>\n' +
'    <yun required="1" cn="孕">$yun$</yun>\n' +
'    <chan required="1" cn="产">$chan$</chan>\n' +
'    <rengongliuchan required="1" cn="人工流产">$rengongliuchan$</rengongliuchan>\n' +
'    <ziranliuchan required="1" cn="自然流产">$ziranliuchan$</ziranliuchan>\n' +
'    <yaoliu required="1" cn="药流">$yaoliu$</yaoliu>\n' +
'    <yinchan required="1" cn="引产">$yinchan$</yinchan>\n' +
'    <zaochan required="1" cn="早产 ">$zaochan$</zaochan>\n' +
'    <gongwaiyunzuo required="1" cn="宫外孕:左">$gongwaiyunzuo$</gongwaiyunzuo>\n' +
'    <gongwaiyunyou required="1" cn="宫外孕:右">$gongwaiyunyou$</gongwaiyunyou>\n' +
'    <gongwaiyunbeizhu required="1" cn="宫外孕备注">$gongwaiyunbeizhu$</gongwaiyunbeizhu>\n' +
'    <zuyuechan required="1" cn="足月产">$zuyuechan$</zuyuechan>\n' +
'    <xianyouzinv required="1" cn="现有子女">$xianyouzinv$</xianyouzinv>\n' +
'    <lingyangzinv required="1" cn="是否领养子女">$lingyangzinv$</lingyangzinv>\n' +
'    <lingyangzinvsl cn="领养子女数量">$lingyangzinvsl$</lingyangzinvsl>\n' +
'    <qita required="1" cn="其他">$hunyushiqita$</qita>\n' +
'  </hunyushi>\n' +
'  <!-- 家族史 -->\n' +
'  <jiazushi>\n' +
'    <yichuanbingshi required="1" cn="遗传病史">$yichuanbingshi$</yichuanbingshi>\n' +
'    <yichuanbingshibeizhu cn="详述">$yichuanbingshibeizhu$</yichuanbingshibeizhu>\n' +
'    <buyunbuyu required="1" cn="不孕不育病史">$buyunbuyu$</buyunbuyu>\n' +
'    <buyunbuyubeizhu cn="详述">$buyunbuyubeizhu$</buyunbuyubeizhu>\n' +
'  </jiazushi>\n' +
'  <!-- 病史小结 -->\n' +
'  <bingshixiaojie>\n' +
'    <bingshixiaojiebeizhu cn="病史小结备注">$bingshixiaojiebeizhu$</bingshixiaojiebeizhu>\n' +
'  </bingshixiaojie>\n' +
'  <zhenduan>\n' +
'    <zhenduanbz1 cn="诊断1">$zhenduanbz1$</zhenduanbz1>\n' +
'    <zhenduanbz2 cn="诊断2">$zhenduanbz2$</zhenduanbz2>\n' +
'    <zhenduanbz3 cn="诊断3">$zhenduanbz3$</zhenduanbz3>\n' +
'    <zhenduanbz4 cn="诊断4">$zhenduanbz4$</zhenduanbz4>\n' +
'    <zhenduanbz5 cn="诊断5">$zhenduanbz5$</zhenduanbz5>\n' +
'    <bingshicaijizhe required="1" cn="病史采集者">$bingshicaijizhe$</bingshicaijizhe>\n' +
'    <yishi required="1" cn="医师">$yishi$</yishi>\n' +
'  </zhenduan>\n' +
'  <chuzhi>\n' +
'    <chuzhibeizhu cn="处置备注">$chuzhibeizhu$</chuzhibeizhu>\n' +
'  </chuzhi>\n' +
'</zhouqimenzhenbingli>'
},
watch: {
trade (val) {
if (this.tradeData) {
for (let i = 0; i < this.tradeData.length; i++) {
if (val === this.tradeData[i].id) {
this.tradeName = this.tradeData[i].tagName
break
}
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/project/perfectMessageProject/perfectMessageWoman.vue